import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

/** All tracked $CARDS airdrops with totals (cached for 5 minutes). */
export function useAirdrops() {
  return useQuery({
    queryKey: ["airdrops"],
    queryFn: async () => {
      const { data, error } = await api.airdrops.get();
      if (error) throw error;
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
